import gql from "graphql-tag";

const LEGAL_QUERY = gql`
  query ($siteHandle: [String]) {
    legal: entries(section: ["legal"], site: $siteHandle) {
      title
      id
      siteId
      siteHandle
      ... on legal_Entry {
        userTitle @parseRefs
        slug
        legalParagraph @parseRefs
      }
    }
  }
`;
export default LEGAL_QUERY;
